const BASE_URL = 'https://www.buxfer.com/api';

export const api = {
  async login(token) {
    const response = await fetch(`${BASE_URL}/accounts?token=${token}`);
    const data = await response.json();
    if (data.response?.status === 'OK') {
      return { success: true, accounts: data.response.accounts || [] };
    }
    throw new Error('Invalid token');
  },

  async fetchAccounts(token) {
    const response = await fetch(`${BASE_URL}/accounts?token=${token}`);
    const data = await response.json();
    if (data.response?.status === 'OK') {
      return data.response.accounts || [];
    }
    throw new Error('Failed to fetch accounts');
  },

  async fetchTransactions(token, accountId = null, page = 1) {
    let url = `${BASE_URL}/transactions?token=${token}&page=${page}`;
    if (accountId) url += `&accountId=${accountId}`;

    const response = await fetch(url);
    const data = await response.json();
    if (data.response?.status === 'OK') {
      return data.response.transactions || [];
    }
    throw new Error('Failed to fetch transactions');
  },

  async fetchLoanTransactions(token, contactId, page = 1) {
    let url = `${BASE_URL}/transactions?token=${token}&page=${page}`;
    if (contactId) url += `&contactId=${contactId}`;

    const response = await fetch(url);
    const data = await response.json();
    if (data.response?.status === 'OK') {
      return data.response.transactions || [];
    }
    throw new Error('Failed to fetch loan transactions');
  },

  async fetchLoans(token) {
    const response = await fetch(`${BASE_URL}/loans?token=${token}`);
    const data = await response.json();
    if (data.response?.status === 'OK') {
      return data.response.loans || [];
    }
    throw new Error('Failed to fetch loans');
  },

  async fetchContacts(token) {
    const response = await fetch(`${BASE_URL}/contacts?token=${token}`);
    const data = await response.json();
    if (data.response?.status === 'OK') {
      return data.response.contacts || [];
    }
    throw new Error('Failed to fetch contacts');
  },

  async addTransaction(token, transactionData) {
    const formData = new URLSearchParams();
    formData.append('token', token);
    Object.entries(transactionData).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        formData.append(key, value.toString());
      }
    });

    const response = await fetch(`${BASE_URL}/transaction_add`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString()
    });

    const data = await response.json();
    if (data.response?.status === 'OK' || data.response?.id) {
      return data.response;
    }
    throw new Error(data.response?.status || 'Failed to add transaction');
  },

  async editTransaction(token, id, transactionData) {
    const formData = new URLSearchParams();
    formData.append('token', token);
    formData.append('id', id);
    Object.entries(transactionData).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        formData.append(key, value.toString());
      }
    });

    const response = await fetch(`${BASE_URL}/transaction_edit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString()
    });

    const data = await response.json();
    if (data.response?.status === 'OK' || data.response?.id) {
      return data.response;
    }
    throw new Error(data.response?.status || 'Failed to edit transaction');
  },

  async deleteTransaction(token, id) {
    const response = await fetch(`${BASE_URL}/transaction_delete?token=${token}&id=${id}`);
    const data = await response.json();
    if (data.response?.status === 'OK') {
      return true;
    }
    throw new Error(data.response?.status || 'Failed to delete transaction');
  }
};
